/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MailMergeService {

    protected basePath = 'https://gateway.dev.meu-solutions.com/staginganawork';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param categoryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMailMergeCategoryCodeCodesGet(categoryCode: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMailMergeCategoryCodeCodesGet(categoryCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMailMergeCategoryCodeCodesGet(categoryCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMailMergeCategoryCodeCodesGet(categoryCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (categoryCode === null || categoryCode === undefined) {
            throw new Error('Required parameter categoryCode was null or undefined when calling apiMailMergeCategoryCodeCodesGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/mailMerge/${encodeURIComponent(String(categoryCode))}/codes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param templateId 
     * @param categoryCode 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMailMergeExportTemplateIdCategoryCodePost(templateId: string, categoryCode: string, body?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public apiMailMergeExportTemplateIdCategoryCodePost(templateId: string, categoryCode: string, body?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public apiMailMergeExportTemplateIdCategoryCodePost(templateId: string, categoryCode: string, body?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public apiMailMergeExportTemplateIdCategoryCodePost(templateId: string, categoryCode: string, body?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling apiMailMergeExportTemplateIdCategoryCodePost.');
        }

        if (categoryCode === null || categoryCode === undefined) {
            throw new Error('Required parameter categoryCode was null or undefined when calling apiMailMergeExportTemplateIdCategoryCodePost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Blob>('post',`${this.basePath}/api/mailMerge/export/${encodeURIComponent(String(templateId))}/${encodeURIComponent(String(categoryCode))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
		responseType: 'blob' as 'json',
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
